import { clientNeoBanks } from "@neonumy/api-clients";
import { useLazyQuery } from "@apollo/client";
import { LIST_BANKS } from "queries/banks";
import { useMemo, useEffect } from "react";
import { onErrorGraphql } from "utils/onErrorGraphql";

export function useListBanksOptions() {
  const [listBanks, { refetch: refetchListBanks, data: listBanksData, error: listBanksError }] =
    useLazyQuery<ListBanksOutput, ListBanksInput>(LIST_BANKS, {
      client: clientNeoBanks,
      fetchPolicy: "no-cache",
    });

  useEffect(() => {
    if (listBanksError) onErrorGraphql(listBanksError);
  }, [listBanksError]);

  const banksOptions: { label: string; value: ID }[] = useMemo(
    () =>
      listBanksData?.listBanks?.results?.map(item => ({
        label: item.name,
        value: item.id,
      })) ?? [],
    [listBanksData],
  );

  return { listBanks, banksOptions, refetchListBanks };
}
